import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';
import { type Registry as Services } from '@ember/service';

export const useDeviceManager = (): Services['deviceManager'] => {
  return useEmberService('deviceManager');
};
